// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2Wab2","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__flWyX"};